import BaseWrapper from "../../../components/ui/BaseWrapper";

export default function CustomerSettingsHeader() {
  return (
    <div className="border-b border-zinc-300 bg-white">
      <BaseWrapper>
        <div className="py-[7px]">
          <h3 className="font-light">Company Settings</h3>
        </div>
      </BaseWrapper>
    </div>
  );
}
